export const Environment = {
   production: true,
   // Allowed routes where the client can access the server
   ServerAdress: '',
}
